import { getLettersGroupTitle, getLettersName } from '@cockpitai/utils'
import { useState } from 'react'
import { tv, VariantProps } from 'tailwind-variants'

const avatarC = tv({
  base: 'overflow-hidden rounded-full',
  variants: {
    isText: {
      true: 'text-base font-bold font-outfit text-white text-opacity-85 bg-gray-700 flex items-center justify-center',
    },
    size: {
      small: 'w-8 h-8',
      medium: 'w-10 h-10',
      large: 'w-12 h-12',
      extralarge: 'w-16 h-16',
    },
  },
  defaultVariants: {
    size: 'medium',
  },
})

type TAvatarProps = {
  imageUrl?: string | null
  title: string
  initialsMode?: 'person' | 'group'
} & VariantProps<typeof avatarC>

export function Avatar({ imageUrl, title, size, initialsMode = 'person' }: TAvatarProps) {
  const [error, setError] = useState(false)

  const initials =
    initialsMode === 'group' ? getLettersGroupTitle(title) : getLettersName(title)

  return (
    <div
      className={'flex-none ' + avatarC({ isText: !imageUrl || error, size })}>
      {!imageUrl || error ? (
        initials
      ) : (
        <img alt={title} src={imageUrl} onError={() => setError(true)} />
      )}
    </div>
  )
}
